import MaxWidthContainer from "components/MaxWidthContainer";
import { ExtraPaddingProps } from "components/PopupsFullPageContainer";
import { Button, Heading, Text } from "iparque-components";
import styled from "styled-components";
import { breakpoints } from "theme/breakpoints";

interface TextProps {
  bold?: boolean;
}

export const LoginButtonContainer = styled(
  MaxWidthContainer
)<ExtraPaddingProps>`
  z-index: 100;
  position: fixed;
  top: 0;
  top: ${({ extraPaddingTop }) => extraPaddingTop ?? 0}px;
  left: 0;
  right: 0;
`;

export const LoginButton = styled(Button)<ExtraPaddingProps>`
  position: absolute;
  right: 0px;
  text-transform: uppercase;
  padding: 20px 28px;
  transition: top
    ${({ extraPaddingTopAnimationDuration }) =>
      extraPaddingTopAnimationDuration}s;
`;

export const TextContainer = styled.div`
  width: 50%;
  margin-bottom: 5%;

  @media (max-width: ${breakpoints.lg}) {
    width: 100%;
    margin-top: 40vh;
  }

  @media (max-width: ${breakpoints.sm}) {
    width: 100%;
    margin-top: 65vw;
  }
`;

export const StyledHeading = styled(Heading)`
  line-height: 1em;
  padding-bottom: 25px;
  max-width: 515px;

  @media (max-width: ${breakpoints.md}) {
    max-width: 430px;
  }

  @media (max-width: ${breakpoints.sm}) {
    max-width: 270px;
  }
`;

export const StyledText = styled(Text).attrs({
  variant: "body5",
  color: "quintenary",
})<TextProps>`
  p {
    margin-bottom: 20px;

    :last-child {
      margin-bottom: 40px;
    }
  }
`;

export const VideoButton = styled(Button)`
  margin-top: 40px;
  float: right;
`;
